import lzString from 'lz-string';

export const compress = (event) => {
  const { data } = event;
  const compressedData = lzString.compress(data);

  postMessage({ action: 'compressed', data: compressedData });
};
